import logoNegro from '../../img/logo.png';
import './style.css';
import logoAmarilloDegradado from '../../img/logoDegradadoAmarillo.png';
import logoVbrassGris from '../../img/vbrassLogoGris.png';
import fbAzul from '../../img/fbAzul.png';
import igAzul from '../../img/igAzul.png';
import lkdAzul from '../../img/lkdAzul.png';
import { useHistory } from 'react-router-dom';

function Contacto() {
    const history = useHistory();

    const handleClick = () => {
        history.push('/'); // cambia a la ruta deseada
    };

    return (  
        <div className="contacto">
            <img src={logoAmarilloDegradado} alt="" className='imgFondo'/>
            <img src={logoVbrassGris} alt="" className='imgVbrass'/>
            <div className="row rowLogo">
                <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-flex">
                    <img src={logoNegro} alt="" width={'70%'} className='mb-0 mt-auto' onClick={handleClick} style={{ cursor: 'pointer' }}/>
                </div>
            </div>
                <div className="row mt-4 rowInfo">
                    <div className="col-xl-4 m-0 d-flex align-items-center justify-content-center">
                        <h1 className='m-0'>Lorem ipsum dolor sit amet</h1>
                    </div>
                    <div className="col-xl-8 mt-3 mt-lg-4 m-xl-0 d-flex align-items-center">
                        <p className='m-0'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
                    </div>
                    <div className="col-xl-4 mt-4 mt-lg-5 mt-xl-3 d-flex justify-content-center justify-content-xl-start">
                        <button className='btnCotiza'>Cotiza tu proyecto</button>
                    </div>
                </div>
                <div className="row mt-5 rowBotones">
                    <div className="col-xl-7">
                    </div>
                    <div className="col-xl-5 mt-lg-4 d-flex justify-content-between">
                        <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnFacebook'>
                            <img src={fbAzul} alt="" className='iconoRedSocial'/>
                        </a>
                        <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnLinkedin'>
                            <img src={lkdAzul} alt="" className='iconoRedSocial'/>
                        </a>
                        <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnInstagram'>
                            <img src={igAzul} alt="" className='iconoRedSocial'/>
                        </a>
                    </div>
                </div>
        </div>
    );
}

export default Contacto;